import { useTranslation } from "react-i18next";
import { useBasicComponents } from "./useBasicComponent";

export const useHadoopConfig = (action = "create", defaultValues = {}) => {
  const { t } = useTranslation();
  const {
    replicas,
    replicasReadOnly,
    core,
    memory,
    version,
    dataDisk,
    logDisk,
    workerMem,
    javaOpts
  } = useBasicComponents(action, defaultValues);

  const zookeeperColumns = () => {
    const group = "zookeeper";
    return [
      replicas({ group }),
      core({ group }),
      memory({ group }),
      version({ group }),
      dataDisk({ group }),
      logDisk({ group }),
      javaOpts(group)
    ];
  };

  const hadoopNNColumns = () => {
    const group = "hadoop-hdfs-nn";
    return [
      replicas({ group }),
      core({ group }),
      memory({ group }),
      version({ group }),
      dataDisk({ group }),
      javaOpts(group)
    ];
  };

  const hadoopJNColumns = () => {
    const group = "hadoop-hdfs-jn";
    return [
      replicas({ group }),
      core({ group }),
      memory({ group }),
      version({ group }),
      dataDisk({ group }),
      javaOpts(group)
    ];
  };

  const hadoopDNColumns = () => {
    const group = "hadoop-hdfs-dn";
    return [
      replicas({ group }),
      core({ group }),
      memory({ group }),
      version({ group }),
      dataDisk({ group }),
      javaOpts(group)
    ];
  };

  const sparkMasterColumns = () => {
    const group = "spark-master";
    return [
      replicas({ group }),
      core({ group }),
      memory({ group }),
      version({ group })
    ];
  };

  const sparkWorkerColumn = () => {
    const group = "spark-worker";
    return [
      replicas({ group }),
      core({ group }),
      memory({ group }),
      version({ group }),
      dataDisk({ group }),
      workerMem({ group }),
    ];
  };

  const hadoopSchema = [
    {
      title: t("config.instance.form.zookeeper", "Zookeeper"),
      valueType: "group",
      columns: zookeeperColumns(),
    },
    {
      title: t("config.instance.form.hadoopNameNode", "Hadoop Name Node"),
      valueType: "group",
      columns: hadoopNNColumns(),
    },
    {
      title: t("config.instance.form.hadoopJournalNode", "Hadoop Journal Node"),
      valueType: "group",
      columns: hadoopJNColumns(),
    },
    {
      title: t("config.instance.form.hadoopDataNode", "Hadoop Data Node"),
      valueType: "group",
      columns: hadoopDNColumns(),
    },
    {
      title: t("config.instance.form.sparkMaster", "Spark Master"),
      valueType: "group",
      columns: sparkMasterColumns(),
    },
    {
      title: t("config.instance.form.sparkWorker", "Spark Worker"),
      valueType: "group",
      columns: sparkWorkerColumn(),
    },
  ];

  return hadoopSchema;
};
